import Http from '../base-http'


class UserBenefit extends Http {
  
}

const userBenefit = new UserBenefit({
  modelUrlPrefix : 'userBenefit'
})

export default userBenefit
